Ext.define('SA.SidebarState', {
    statics: {
        create() {
            return new SA.SidebarState();
        }
    },

    apply() {
        SA.Sidebar.hideMask();

        SA.Sidebar.setModel(this.model);
        SA.Sidebar.setEnabledTabs(this.enabledTabs);
        SA.Sidebar.setSelectedTab(this.selectedTab);
        SA.Sidebar.setTabMouseOverListener(this.tabMouseOverListener ?? null);
        SA.Sidebar.showToolbarTabs();
        SA.Sidebar.setHandlers(this.handlers ?? null);
    },

    enableTabs(enabledTabs) {
        return this.set({enabledTabs});
    },

    selectTab(selectedTab) {
        return this.set({selectedTab});
    },

    set(param) {
        return Object.assign(this, param);
    },

    setHandlers(handlers) {
        return this.set({handlers});
    },

    setModel(model) {
        return this.set({model});
    },

    setTabMouseOverListener(tabMouseOverListener) {
        return this.set({tabMouseOverListener});
    }
});